import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=60d6d865&scoped=true&"
import script from "./questionEdit.vue?vue&type=script&lang=ts&"
export * from "./questionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./questionEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./questionEdit.vue?vue&type=style&index=1&id=60d6d865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6d865",
  null
  
)

export default component.exports